<header>
  <h2>{{ title }}</h2>
  
  <button mat-icon-button (click)="copyUrl()">
    <mat-icon>link</mat-icon>
  </button>

  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>

</header>
<!-- p style="font-size: large">Tableau Panel</p -->
<div id="vizContainer" class="container"></div>
